import { Component, type ReactNode } from 'react';
import { Button } from './Button';

export class ErrorBoundary extends Component<{ children: ReactNode; fallback?: ReactNode }, { error: Error | null }> {
  override state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  override componentDidCatch(error: Error) {
    console.error(error);
  }
  override render() {
    if (this.state.error) {
      return (
        this.props.fallback ?? (
          <div className="flex h-full flex-col items-center justify-center gap-3 p-8 text-center">
            <div className="text-sm font-medium">Something went wrong</div>
            <pre className="max-w-lg overflow-auto rounded bg-bg-sunken p-2 text-left text-xs text-fg-muted">{this.state.error.message}</pre>
            <Button variant="primary" onClick={() => location.reload()}>
              Reload
            </Button>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
